<template>
  <span>
    <slot v-if="!busy" name="button">
      <b-button
        :variant="variant"
        :size="size"
        :class="buttonClass"
        @click="runAction">
          {{ buttonText || 'Run action' }}
        </b-button>
    </slot>
    <slot v-if="busy" name="busy">
      <b-button
        :variant="`outline-${variant}`"
        :size="size"
        :disabled="true"
        :class="buttonClass">
          <i class="fas fa-ghost"></i>
          {{ busyText || 'Please wait' }}&hellip;
      </b-button>
    </slot>
  </span>
</template>

<script>
export default {
  props: [
    'actionName',
    'parameters',
    'buttonText',
    'busyText',
    'buttonClass',
    'variant',
    'size'
  ],
  data () {
    return {
      busy: false
    }
  },
  methods: {
    runAction () {
      this.busy = true
      this.$emit('running')
      this.$reportingApi.runAction('landscape', this.$store.state.oidcStore.access_token, {
        actionName: this.actionName,
        parameters: this.parameters
      })
      .then(() => this.$emit('done'))
      .catch((e) => this.$emit('error'))
      .finally(() => this.busy = false)
    }
  }
}
</script>
